import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";

import SezarParameterValidatedAttribute from "./SezarParameterValidatedAttribute";

export default Node.create({
    name: "sezar-parameter",
    inline: true,
    group: "inline",

    addAttributes() {
        return {
            attributeName: {
                default: "any",
            },
            validationType: {
                default: "any",
            },
            "data-id": {
                default: "default",
            },
            omitValidation: {
                default: "",
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "sezar-parameter",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["sezar-parameter", mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
        return VueNodeViewRenderer(SezarParameterValidatedAttribute);
    },
});
